/**
 * Comformidable Custom Cart Drawer
 * Vervangt Qikify volledig.
 * Features: AJAX cart, reward tiers, upsell via recommendations API,
 *           kortingscode, dynamische levertijd per markt, feestdagen
 */

(function () {
  'use strict';

  // ─── Config (ingesteld vanuit Liquid) ────────────────────────────────────
  const CONFIG = window.cfCartConfig || {};
  const i18n    = CONFIG.i18n || {};
  const ROOT   = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const DELIVERY_CONFIG = CONFIG.delivery || {};
  const REWARD_TIERS    = CONFIG.rewardTiers || [
    { minItems: 2, discount: 10, code: 'STAF10' },
    { minItems: 3, discount: 15, code: 'STAF15' },
    { minItems: 5, discount: 25, code: 'STAF25' }
  ];

  // ─── State ───────────────────────────────────────────────────────────────
  let _cart          = null;
  let _upsellLoaded  = false;
  let _qtyDebounce   = {};
  let _toastTimer    = null;

  // ─── DOM refs ────────────────────────────────────────────────────────────
  const $ = (id) => document.getElementById(id);
  const drawer        = document.getElementById('cf-cart-drawer');
  const overlay       = document.getElementById('cf-cart-overlay');

  // ─── Utilities ───────────────────────────────────────────────────────────
  function formatMoney(cents) {
    if (cents === null || cents === undefined || isNaN(cents)) cents = 0;
    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    const locale   = document.documentElement.lang || 'nl-NL';
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(cents / 100);
    } catch (e) {
      return '€' + (cents / 100).toFixed(2).replace('.', ',');
    }
  }

  // ─── Valuta (27-10-2026) ─────────────────────────────────────────────────
  // Alle drempels in het thema staan in eurocenten. Ziet de klant een andere
  // valuta (bijv. DKK), dan rekenen we om met de koers van Shopify. In euro
  // verandert er niets. naarBoven: afronden op hele kronen/franken enz., net
  // als de Function doet voor de cadeaudrempels, zodat lade en kassa gelijk zijn.
  function cfValuta() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
  }
  function cfNaarValuta(eurCenten, naarBoven) {
    const rate = parseFloat(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate);
    if (cfValuta() === 'EUR' || !(rate > 0)) return eurCenten;
    const c = eurCenten * rate;
    return naarBoven ? Math.ceil(c / 100) * 100 : Math.round(c);
  }
  // Locale-teksten met "€{{threshold}}": buiten euro het hele bedrag in de juiste valuta.
  function cfDrempelTekst(tekst, cents) {
    if (cfValuta() === 'EUR') return tekst.replace('{{threshold}}', (cents / 100).toFixed(0));
    return tekst.replace(/€\s?\{\{threshold\}\}|\{\{threshold\}\}\s?€|\{\{threshold\}\}/, formatMoney(cents));
  }

  // Verwijdert letterlijke <strong> uit ge-escapete locale strings en zet ze om naar echte tags
  function unescapeStrong(str) {
    if (!str) return str;
    return str
      .replace(/&lt;strong&gt;/g, '<strong>')
      .replace(/&lt;\/strong&gt;/g, '</strong>')
      .replace(/&lt;br&gt;/g, '<br>')
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/&amp;/g, '&');
  }

  function showToast(msg, duration = 2800) {
    let el = document.querySelector('.cf-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'cf-toast';
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.classList.add('cf-toast--show');
    clearTimeout(_toastTimer);
    _toastTimer = setTimeout(() => el.classList.remove('cf-toast--show'), duration);
  }

  // ─── DELIVERY LOGIC ──────────────────────────────────────────────────────

  /**
   * Bepaal de verwachte leverdatum op basis van:
   * - Huidig tijdstip (Amsterdam timezone)
   * - Markt (NL/BE = cut-off 23u, rest = 10u)
   * - Feestdagen / gesloten dagen
   * - Verzendtijden per markt
   */
  function getDeliveryText() {
    const now = new Date();

    // Amsterdam tijd
    const amsTZ   = 'Europe/Amsterdam';
    const amsNow  = new Date(now.toLocaleString('en-US', { timeZone: amsTZ }));
    const hour    = amsNow.getHours();
    const minute  = amsNow.getMinutes();

    const market  = (CONFIG.market || '').toLowerCase();
    const isNLBE  = market === 'nl' || market === 'be' || market === 'belgie' || market === '' || !market; // NL + BE = volgende werkdag
    const satDeliveryMap = DELIVERY_CONFIG.saturdayDelivery || {};
    const satDelivery = isNLBE && (market === 'be' || market === 'belgie' ? satDeliveryMap.BE === true : satDeliveryMap.NL !== false);

    const cutoff  = isNLBE ? DELIVERY_CONFIG.cutoffNLBE || 23 : DELIVERY_CONFIG.cutoffOther || 10;
    const holidays = (DELIVERY_CONFIG.holidays || []).concat(DELIVERY_CONFIG.extraClosedDays || []);

    // Controleer of vandaag een feestdag is
    function isHoliday(date) {
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const dd = String(date.getDate()).padStart(2, '0');
      const yyyy = date.getFullYear();
      const ymd  = `${yyyy}-${mm}-${dd}`;
      const mmd  = `${mm}-${dd}`;
      return holidays.includes(ymd) || holidays.includes(mmd);
    }

    // Volgende werkdag (maandag t/m vrijdag, geen feestdag)
    function nextWorkday(from, skipToday = false) {
      const d = new Date(from);
      if (skipToday) d.setDate(d.getDate() + 1);
      while (true) {
        const dow = d.getDay(); // 0=zo, 6=za
        if (dow !== 0 && dow !== 6 && !isHoliday(d)) return d;
        d.setDate(d.getDate() + 1);
      }
    }

    // Volgende bezorgdag (zaterdag toegestaan voor NL)
    function nextDeliveryDay(from) {
      const d = new Date(from); d.setDate(d.getDate() + 1);
      while (true) { const dow = d.getDay(); if (dow !== 0 && (satDelivery || dow !== 6) && !isHoliday(d)) return d; d.setDate(d.getDate() + 1); }
    }

    // Voeg N werkdagen toe
    function addWorkdays(from, n) {
      let d = new Date(from);
      let added = 0;
      while (added < n) {
        d.setDate(d.getDate() + 1);
        const dow = d.getDay();
        if (dow !== 0 && dow !== 6 && !isHoliday(d)) added++;
      }
      return d;
    }

    // Dagformat
    const dayNames = {
      'nl': ['zondag','maandag','dinsdag','woensdag','donderdag','vrijdag','zaterdag'],
      'de': ['Sonntag','Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag'],
      'fr': ['dimanche','lundi','mardi','mercredi','jeudi','vendredi','samedi'],
      'da': ['søndag','mandag','tirsdag','onsdag','torsdag','fredag','lørdag'],
      'en': ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday']
    };
    const locale = (CONFIG.locale || 'nl').toLowerCase().substring(0, 2);
    const days   = dayNames[locale] || dayNames['nl'];

    function formatDate(d) {
      const dow = days[d.getDay()];
      const dd  = d.getDate();
      const monthNames = {
        'nl': ['jan','feb','mrt','apr','mei','jun','jul','aug','sep','okt','nov','dec'],
        'de': ['Jan','Feb','Mär','Apr','Mai','Jun','Jul','Aug','Sep','Okt','Nov','Dez'],
        'fr': ['jan','fév','mar','avr','mai','jun','jul','aoû','sep','oct','nov','déc'],
        'da': ['jan','feb','mar','apr','maj','jun','jul','aug','sep','okt','nov','dec'],
        'en': ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']
      };
      const months = monthNames[locale] || monthNames['nl'];
      return `${dow} ${dd} ${months[d.getMonth()]}`;
    }

    const beforeCutoff = hour < cutoff || (hour === cutoff && minute === 0);
    const todayIsWorkday = amsNow.getDay() !== 0 && amsNow.getDay() !== 6 && !isHoliday(amsNow);

    let deliveryDate;
    let prefix;

    if (isNLBE) {
      // NL/BE: voor 23:00 op werkdag = morgen
      if (beforeCutoff && todayIsWorkday) {
        deliveryDate = nextDeliveryDay(amsNow);
      } else {
        // Na cutoff of weekend: volgende werkdag daarna
        const nextDay = nextWorkday(amsNow, !todayIsWorkday || !beforeCutoff);
        deliveryDate  = nextDeliveryDay(nextDay);
      }

      // Check of vandaag/gisteren van toepassing is
      const tomorrow = new Date(amsNow);
      tomorrow.setDate(tomorrow.getDate() + 1);
      const isTomorrow = deliveryDate.getDate() === tomorrow.getDate() &&
                         deliveryDate.getMonth() === tomorrow.getMonth();

      if (beforeCutoff && todayIsWorkday) {
        prefix = `Voor ${cutoff}:00 besteld = `;
        if (isTomorrow) {
          prefix += 'morgen in huis';
          deliveryDate = null;
        }
      } else {
        prefix = 'Besteld = ';
      }
    } else {
      // Internationaal: 1-4 werkdagen (toon 2 werkdagen als verwacht, 4 als uiterlijk)
      const dispatchDay  = beforeCutoff && todayIsWorkday
        ? amsNow
        : nextWorkday(amsNow, true);

      // 2-4 werkdagen voor alle internationale markten
      deliveryDate = addWorkdays(dispatchDay, 2);
      const latestDate = addWorkdays(dispatchDay, 4);

      const deliveryLabels = {
        'nl': `Verwacht ${formatDate(deliveryDate)} – ${formatDate(latestDate)}`,
        'de': `Voraussichtlich ${formatDate(deliveryDate)} – ${formatDate(latestDate)}`,
        'fr': `Livraison prévue ${formatDate(deliveryDate)} – ${formatDate(latestDate)}`,
        'da': `Forventet ${formatDate(deliveryDate)} – ${formatDate(latestDate)}`,
        'en': `Expected ${formatDate(deliveryDate)} – ${formatDate(latestDate)}`
      };
      return deliveryLabels[locale] || deliveryLabels['nl'];
    }

    if (deliveryDate === null) {
      return prefix;
    }
    return prefix + formatDate(deliveryDate);
  }

  function renderDelivery() {
    const el = $('cf-delivery-text');
    if (el) el.textContent = getDeliveryText();
  }

  // ─── REWARD TIER BAR ─────────────────────────────────────────────────────

  function renderRewardBar(itemCount) {
    const msgEl  = $('cf-reward-message');
    const barEl  = $('cf-reward-bar-fill');
    const section = $('cf-reward-section');
    if (!msgEl || !barEl) return;

    // Bepaal huidige en volgende tier
    let currentTier = null;
    let nextTier    = null;

    for (const tier of REWARD_TIERS) {
      if (itemCount >= tier.minItems) {
        currentTier = tier;
      } else if (!nextTier) {
        nextTier = tier;
      }
    }

    const maxItems  = REWARD_TIERS[REWARD_TIERS.length - 1].minItems;
    const fillPct   = Math.min((itemCount / maxItems) * 100, 100);
    barEl.style.width = fillPct + '%';

    // Markers actief maken
    document.querySelectorAll('.cf-reward__tier-marker').forEach((marker, i) => {
      const tier = REWARD_TIERS[i];
      marker.classList.toggle('cf-tier--active', tier && itemCount >= tier.minItems);
    });

    if (currentTier && !nextTier) {
      const unlockedMsg = unescapeStrong(i18n.rewardUnlocked || 'Je hebt {{discount}} korting ontgesloten!')
        .replace('{{discount}}', currentTier.discount + '%');
      msgEl.innerHTML = '🎉 ' + unlockedMsg;
      msgEl.classList.add('cf-reward--unlocked');
    } else if (nextTier) {
      const needed  = nextTier.minItems - itemCount;
      const artWord = needed === 1 ? (i18n.rewardArticle || 'artikel') : (i18n.rewardArticles || 'artikelen');
      const addText = i18n.rewardAdd || 'Voeg nog';
      const forText = i18n.rewardFor || 'toe voor';
      const discText = i18n.rewardDiscount || 'korting';
      msgEl.innerHTML = `${addText} <strong>${needed} ${artWord}</strong> ${forText} <strong>${nextTier.discount}% ${discText}</strong>!`;
      msgEl.classList.remove('cf-reward--unlocked');
    } else {
      msgEl.innerHTML = i18n.rewardAdd || 'Voeg artikelen toe voor staffelkorting!';
      msgEl.classList.remove('cf-reward--unlocked');
    }
  }


  // ─── FREE SHIPPING BAR ───────────────────────────────────────────────────

  function getShippingThreshold() {
    const country   = (CONFIG.market || 'NL').toUpperCase();
    const thresholds = (CONFIG.shipping && CONFIG.shipping.thresholds) || {};
    return cfNaarValuta(thresholds[country] || thresholds['default'] || 3000, true);
  }

  function renderShippingBar(cart) {
    const barEl     = $('cf-shipping-bar');
    const msgEl     = $('cf-shipping-message');
    const fillEl    = $('cf-shipping-fill');
    if (!barEl || !msgEl || !fillEl) return;

    if (!cart || cart.item_count === 0) {
      barEl.style.display = 'none';
      return;
    }

    const threshold = getShippingThreshold();
    const total     = cart.total_price || 0;
    const remaining = Math.max(0, threshold - total);
    const pct       = Math.min(100, (total / threshold) * 100);

    barEl.style.display = 'block';
    fillEl.style.width  = pct + '%';

    if (remaining <= 0) {
      msgEl.innerHTML = unescapeStrong(i18n.shippingUnlocked || '🎉 Gratis verzending!');
      fillEl.classList.add('cf-shipping--unlocked');
    } else {
      fillEl.classList.remove('cf-shipping--unlocked');
      const amountFormatted = formatMoney(remaining);
      const msg = unescapeStrong(i18n.shippingRemaining || 'Nog <strong>{{amount}}</strong> tot gratis verzending!')
        .replace('{{amount}}', amountFormatted);
      msgEl.innerHTML = msg;
    }
  }

  // ─── COUNTDOWN TIMER ─────────────────────────────────────────────────────

  let _countdownInterval = null;

  function startCountdown() {
    const countdownEl = $('cf-delivery-countdown');
    const timeEl      = $('cf-countdown-time');
    if (!countdownEl || !timeEl) return;

    const amsTZ   = 'Europe/Amsterdam';
    const market  = (CONFIG.market || '').toLowerCase();
    const isNLBE  = market === 'nl' || market === 'be' || market === 'belgie' || market === '' || !market; // NL + BE = volgende werkdag
    const cutoff  = isNLBE
      ? (DELIVERY_CONFIG.cutoffNLBE || 23)
      : (DELIVERY_CONFIG.cutoffOther || 22);

    function tick() {
      const now    = new Date();
      const amsNow = new Date(now.toLocaleString('en-US', { timeZone: amsTZ }));
      const hour   = amsNow.getHours();
      const min    = amsNow.getMinutes();
      const sec    = amsNow.getSeconds();
      const dow    = amsNow.getDay(); // 0=zo, 6=za

      // Alleen tonen op werkdagen vóór cutoff
      const isWorkday   = dow >= 1 && dow <= 5;
      const beforeCutoff = hour < cutoff;

      if (!isWorkday || !beforeCutoff) {
        countdownEl.style.display = 'none';
        return;
      }

      // Bereken resterende tijd tot cutoff
      const totalSecsLeft = (cutoff - hour - 1) * 3600 + (59 - min) * 60 + (59 - sec);
      if (totalSecsLeft <= 0) {
        countdownEl.style.display = 'none';
        return;
      }

      const hLeft = Math.floor(totalSecsLeft / 3600);
      const mLeft = Math.floor((totalSecsLeft % 3600) / 60);
      const sLeft = totalSecsLeft % 60;

      const timeStr = hLeft > 0
        ? `${hLeft}u ${String(mLeft).padStart(2,'0')}m`
        : `${mLeft}m ${String(sLeft).padStart(2,'0')}s`;

      const label = (i18n.countdownLabel || 'nog {{time}}').replace('{{time}}', timeStr);
      timeEl.textContent = label;
      countdownEl.style.display = 'inline';
    }

    clearInterval(_countdownInterval);
    tick();
    _countdownInterval = setInterval(tick, 1000);
  }

  function stopCountdown() {
    clearInterval(_countdownInterval);
    const countdownEl = $('cf-delivery-countdown');
    if (countdownEl) countdownEl.style.display = 'none';
  }


  // ─── DREMPEL MELDING ─────────────────────────────────────────────────────
  // Detecteert of staffelkorting de klant onder de gratis verzending drempel duwt
  // En suggereert het volgende tier als dat hen verder helpt

  function renderThresholdWarning(cart) {
    const warningEl = $('cf-threshold-warning');
    const msgEl     = $('cf-threshold-message');
    if (!warningEl || !msgEl) return;

    const itemCount   = cfBetaaldAantal(cart.items);
    const subtotal    = cart.total_price || 0; // prijs NA korting
    const threshold   = getShippingThreshold();

    // Bepaal huidige actieve tier op basis van item count
    let activeTier = null;
    for (const tier of REWARD_TIERS) {
      if (itemCount >= tier.minItems) activeTier = tier;
    }

    // Geen korting actief of al boven drempel → geen melding
    if (!activeTier || subtotal >= threshold) {
      warningEl.style.display = 'none';
      return;
    }

    // Klant heeft korting maar zakt onder gratis verzending drempel
    const needed = threshold - subtotal;

    // Kijk of er een volgend tier is dat de klant nog meer voordeel geeft
    const nextTier = REWARD_TIERS.find(t => t.minItems > itemCount);

    let msg = '';

    if (nextTier) {
      // Suggestie: voeg X toe voor volgend tier + gratis verzending
      // Bereken hoeveel extra nodig is om boven drempel te komen bij volgend tier
      // Benadering: huidige prijs per item als gemiddelde
      const avgItemPrice = cart.items.length > 0
        ? cart.items.reduce((sum, i) => sum + i.original_price, 0) / cart.items.length
        : 0;

      // Met het volgende tier percentage: hoeveel moet subtotaal zijn voor gratis verzending?
      const neededForNextTier = Math.ceil(threshold / (1 - nextTier.discount / 100));
      const currentOriginalTotal = cart.items.reduce((sum, i) => sum + i.original_line_price, 0);
      const extraNeeded = Math.max(0, neededForNextTier - currentOriginalTotal);

      if (extraNeeded > 0 && extraNeeded < threshold) {
        // Suggestie: voeg toe voor volgend tier én gratis verzending
        msg = unescapeStrong(i18n.thresholdSuggestion || '💡 Voeg nog <strong>{{amount}}</strong> toe voor {{discount}}% korting én gratis verzending.')
          .replace('{{amount}}', formatMoney(extraNeeded))
          .replace('{{discount}}', nextTier.discount);
      } else {
        // Gewone waarschuwing
        msg = cfDrempelTekst(unescapeStrong(i18n.thresholdWarning || '⚠️ Met je staffelkorting zakt je totaal onder €{{threshold}}. Voeg nog <strong>{{amount}}</strong> toe voor gratis verzending.'), threshold)
          .replace('{{amount}}', formatMoney(needed));
      }
    } else {
      // Al op hoogste tier — gewone waarschuwing
      msg = cfDrempelTekst(unescapeStrong(i18n.thresholdWarning || '⚠️ Met je staffelkorting zakt je totaal onder €{{threshold}}. Voeg nog <strong>{{amount}}</strong> toe voor gratis verzending.'), threshold)
        .replace('{{amount}}', formatMoney(needed));
    }

    msgEl.innerHTML = msg;
    warningEl.style.display = 'block';
  }

  // ─── CART API ─────────────────────────────────────────────────────────────

  async function fetchCart() {
    const res  = await fetch(`${ROOT}cart.js?t=${Date.now()}`, {
      headers: { 'Accept': 'application/json' }
    });
    const cart = await res.json();
    _cart = cart;
    return cart;
  }

  async function addToCart(variantId, quantity = 1, properties = {}) {
    const res = await fetch(`${ROOT}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity, properties }] })
    });
    if (!res.ok) {
      const err = await res.json();
      throw new Error(err.description || 'Kon product niet toevoegen');
    }
    return res.json();
  }

  async function changeCartItem(key, quantity) {
    const res = await fetch(`${ROOT}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    if (!res.ok) {
      const fout = new Error('cart change ' + res.status);
      fout.stockFout = res.status === 422;
      throw fout;
    }
    return res.json();
  }

  async function applyDiscount(code) {
    const res = await fetch(`${ROOT}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: code })
    });
    return res.json();
  }

  // ─── CART RENDER ─────────────────────────────────────────────────────────

  function renderCart(cart) {
    const itemsEl   = $('cf-cart-items');
    const emptyEl   = $('cf-cart-empty');
    const footerEl  = $('cf-cart-footer');
    const rewardEl  = $('cf-reward-section');
    const countEl   = $('cf-cart-count');

    if (!itemsEl) return;

    const itemCount = cart.item_count || 0;
    if (countEl) countEl.textContent = itemCount;

    // Update alle cart badges op de pagina
    document.querySelectorAll('[data-cart-count], .cart-count, .cf-badge, #cfm-cart-count').forEach(el => {
      el.textContent = itemCount;
    });

    if (itemCount === 0) {
      itemsEl.innerHTML = '';
      var leegCadeau = document.getElementById('cfKitCadeau');
      if (leegCadeau) { leegCadeau.hidden = true; leegCadeau.innerHTML = ''; }
      var leegMasker = document.getElementById('cfMaskerCadeau');
      if (leegMasker) { leegMasker.hidden = true; leegMasker.innerHTML = ''; }
      if (emptyEl) emptyEl.style.display = 'flex';
      if (footerEl) footerEl.style.display = 'none';
      if (rewardEl) rewardEl.style.display = 'none';
      return;
    }

    if (emptyEl) emptyEl.style.display = 'none';
    if (footerEl) footerEl.style.display = 'block';
    if (rewardEl) rewardEl.style.display = 'block';

    // Render items
    itemsEl.innerHTML = cart.items.map(item => {
      const imgSrc = item.featured_image && item.featured_image.url
        ? item.featured_image.url.replace('.jpg', '_120x120.jpg').replace('.png', '_120x120.png')
        : '';
      const variantInfo = item.variant_title && item.variant_title !== 'Default Title'
        ? `<div class="cf-cart-item__variant">${item.variant_title}</div>` : '';
      // Laat zien dat een regel een abonnement is, anders ziet de klant alleen
      // een lagere prijs zonder te weten waarom.
      const aboInfo = item.selling_plan_allocation
        ? `<div class="cf-cart-item__abo">↻ ${item.selling_plan_allocation.selling_plan.name}</div>`
        : (cfIsMaskerCadeau(item) ? `<div class="cf-cart-item__abo">🎁 ${CFM.label}</div>` : '');
      return `
        <div class="cf-cart-item" data-key="${item.key}" data-variant-id="${item.variant_id}">
          <img class="cf-cart-item__image" src="${imgSrc || 'data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'72\' height=\'72\'%3E%3Crect fill=\'%23f3f4f6\' width=\'72\' height=\'72\'/%3E%3C/svg%3E'}"
               alt="${item.product_title}" loading="lazy" width="72" height="72">
          <div class="cf-cart-item__info">
            <div class="cf-cart-item__title">${item.product_title}</div>
            ${variantInfo}
            ${aboInfo}
            <div class="cf-cart-item__bottom">
              <div class="cf-qty-control">
                <button class="cf-qty-btn cf-qty-minus" data-key="${item.key}" aria-label="Minder" ${item.quantity <= 1 ? '' : ''}>−</button>
                <span class="cf-qty-display">${item.quantity}</span>
                <button class="cf-qty-btn cf-qty-plus" data-key="${item.key}" aria-label="Meer">+</button>
              </div>
              <div class="cf-cart-item__price-col">
                <span class="cf-cart-item__price">${formatMoney(item.final_line_price)}</span>
                <button class="cf-cart-item__remove" data-key="${item.key}" aria-label="Verwijder ${item.product_title}">×</button>
              </div>
            </div>
          </div>
        </div>`;
    }).join('');

    // Reward bar: alleen betaalde artikelen tellen, net als de Function (cadeaus niet)
    renderRewardBar(cfBetaaldAantal(cart.items));
    cfBundelStaffelTekst(cart.items);
    renderKitCadeau(cart, itemsEl);
    renderMaskerCadeau(cart, itemsEl);
    renderTrioTip(cart, itemsEl);

    // Gratis verzending bar
    renderShippingBar(cart);

    // Drempel melding
    renderThresholdWarning(cart);

    // Totalen
    renderTotals(cart);

    // Kortingscodes
    renderDiscountCodes(cart);

    // Upsell laden (eenmalig of bij wijziging eerste product)
    loadUpsell(cart);
  }

  function renderTotals(cart) {
    const totalEl    = $('cf-total-price');
    const discountRow = $('cf-discount-row');
    const discountAmt = $('cf-discount-amount');
    const discountLbl = $('cf-discount-label');

    if (totalEl) totalEl.innerHTML = `<strong>${formatMoney(cart.total_price)}</strong>`;

    // Automatische kortingen
    const autoDiscounts = cart.cart_level_discount_applications || [];
    if (autoDiscounts.length > 0 && discountRow) {
      const totalDiscount = autoDiscounts.reduce((sum, d) => sum + (d.total_allocated_amount || 0), 0);
      discountRow.style.display = 'flex';
      if (discountAmt) discountAmt.textContent = `−${formatMoney(totalDiscount)}`;
      if (discountLbl) discountLbl.textContent = autoDiscounts.map(d => d.title).join(', ');
    } else if (discountRow) {
      discountRow.style.display = 'none';
    }
  }

  function renderDiscountCodes(cart) {
    const activeCodesEl = $('cf-discount-active-codes');
    if (!activeCodesEl) return;

    const codes = cart.discount_codes || [];
    activeCodesEl.innerHTML = codes
      .filter(dc => dc.applicable)
      .map(dc => `
        <span class="cf-discount__active-tag">
          ✓ ${dc.code}
          <button class="cf-discount__remove-code" data-code="${dc.code}" aria-label="Verwijder kortingscode ${dc.code}">×</button>
        </span>
      `).join('');
  }

  // ─── UPSELL via Shopify Recommendations API ───────────────────────────────

  async function loadUpsell(cart) {
    const upsellEl  = $('cf-cart-upsell');
    const sliderEl  = $('cf-upsell-slider');
    if (!upsellEl || !sliderEl || cart.items.length === 0) return;

    // ── Regel-gebaseerde cross-sells (kloppende paren per productgroep) ──
    // De anti-snurkkit (goedkoop) komt als eerste suggestie wanneer de cart
    // nog onder de gratis-verzenddrempel zit: kleine toevoeging, gratis verzending.
    const RULES = [
      { re: /neusdouche/i,                s: ['comformidable-nasaal-spoelzout-50-stuks'] },
      { re: /spoelzout/i,                 s: ['neusdouche-90-zakjes-spoelzout'] },
      { re: /magnetisch/i,                s: ['magnetische-neusstrips-refill-100'] },
      { re: /neusstrip|neuspleister/i,    s: ['mondtape-30-stuks'] },
      { re: /mondtape/i,                  s: ['anti-snurk-neusstrips-100-stuks'] },
      { re: /hydra lift/i,                s: ['comformidable-collagen-calm-balance-mask-purifying-calming-4-stuks', 'comformidable-collagen-glow-boost-mask-brightening-radiance-4-stuks'] },
      { re: /calm balance/i,              s: ['comformidable®-collagen-hydra-lift-mask-deep-hydration-firming-4-stuks', 'comformidable-collagen-glow-boost-mask-brightening-radiance-4-stuks'] },
      { re: /glow boost/i,                s: ['comformidable®-collagen-hydra-lift-mask-deep-hydration-firming-4-stuks', 'comformidable-collagen-calm-balance-mask-purifying-calming-4-stuks'] },
      { re: /slaappleister|sleep patch/i, s: ['mondtape-30-stuks'] }
    ];
    const FILLER = 'anti-snurk-kit-compleet';

    const cartProductIds = cart.items.map(i => i.product_id);
    const cartHandles    = cart.items.map(i => i.handle);

    const wanted = [];
    let drempel = 3000;
    try { drempel = getShippingThreshold(); } catch (e) {}
    if (cart.total_price < drempel && !cartHandles.includes(FILLER)) wanted.push(FILLER);
    for (const item of cart.items) {
      for (const rule of RULES) {
        if (rule.re.test(item.title || '')) {
          for (const h of rule.s) {
            if (!cartHandles.includes(h) && !wanted.includes(h)) wanted.push(h);
          }
        }
      }
    }

    try {
      // 1) regel-producten ophalen (alleen leverbaar tonen)
      const ruleProducts = [];
      for (const h of wanted.slice(0, 4)) {
        try {
          const r = await fetch(`${ROOT}products/${encodeURIComponent(h)}.js`);
          if (r.ok) {
            const p = await r.json();
            if (p.variants && p.variants[0] && p.variants[0].available) ruleProducts.push(p);
          }
        } catch (e) {}
      }

      // 2) aanvullen met Shopify-aanbevelingen
      const firstProductId = cart.items[0].product_id;
      let recs = [];
      try {
        const res  = await fetch(`${ROOT}recommendations/products.json?product_id=${firstProductId}&limit=8&intent=related`);
        const data = await res.json();
        recs = (data.products || []);
      } catch (e) {}

      const seen = new Set(cartProductIds.concat(ruleProducts.map(p => p.id)));
      const extra = recs.filter(p => !seen.has(p.id) && p.variants && p.variants[0] && p.variants[0].available);
      const producten = ruleProducts.concat(extra).slice(0, 5);

      if (producten.length === 0) {
        upsellEl.style.display = 'none';
        return;
      }

      upsellEl.style.display = 'block';
      sliderEl.innerHTML = producten.map(product => {
        const variant  = product.variants && product.variants[0];
        const imgSrc   = product.featured_image || '';
        const price    = variant ? formatMoney(variant.price) : '';
        const soldOut  = variant && !variant.available;
        return `
          <div class="cf-upsell-card">
            <img class="cf-upsell-card__image" src="${imgSrc}" alt="${product.title}" loading="lazy">
            <div class="cf-upsell-card__body">
              <div class="cf-upsell-card__title">${product.title}</div>
              <div class="cf-upsell-card__price">${price}</div>
              <button class="cf-upsell-card__add"
                      data-variant-id="${variant ? variant.id : ''}"
                      ${soldOut ? 'disabled' : ''}>
                ${soldOut ? (i18n.soldOut || 'Uitverkocht') : (i18n.addToCart || 'Toevoegen')}
              </button>
            </div>
          </div>`;
      }).join('');

    } catch (e) {
      console.warn('[CF Cart] Upsell laden mislukt:', e);
      upsellEl.style.display = 'none';
    }
  }

  // ─── DRAWER OPEN / CLOSE ─────────────────────────────────────────────────

  async function openDrawer() {
    if (!drawer) return;
    renderDelivery();
    startCountdown();
    const cart = await fetchCart();
    renderCart(cart);
    drawer.classList.add('cf-is-open');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.removeAttribute('inert');
    if (overlay) overlay.classList.add('cf-is-open');
    document.body.style.overflow = 'hidden';
    // Focus management
    const closeBtn = $('cf-cart-close');
    if (closeBtn) closeBtn.focus();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('cf-is-open');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('inert', '');
    if (overlay) overlay.classList.remove('cf-is-open');
    document.body.style.overflow = '';
    stopCountdown();
  }

  // ─── EVENT LISTENERS ─────────────────────────────────────────────────────

  function initEvents() {
    // Sluit knop
    const closeBtn = $('cf-cart-close');
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

    // Overlay klik
    if (overlay) overlay.addEventListener('click', closeDrawer);

    // ESC toets
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer && drawer.classList.contains('cf-is-open')) {
        closeDrawer();
      }
    });

    // Doorgaan winkelen (lege cart)
    const continueBtn = $('cf-continue-shopping');
    if (continueBtn) continueBtn.addEventListener('click', closeDrawer);

    // Cart icon / cart knop openen — ondersteunt Minimog's eigen trigger
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-open-cart], .js-open-cart, [href="/cart"]');
      if (trigger && !trigger.closest('#cf-cart-drawer')) {
        e.preventDefault();
        openDrawer();
      }
    });

    // Quantity +/- en verwijder (event delegation op items container)
    const itemsEl = $('cf-cart-items');
    if (itemsEl) {
      itemsEl.addEventListener('click', handleItemAction);
    }

    // Upsell toevoegen
    const upsellEl = $('cf-cart-upsell');
    if (upsellEl) {
      upsellEl.addEventListener('click', async (e) => {
        const btn = e.target.closest('.cf-upsell-card__add');
        if (!btn || btn.disabled) return;
        const variantId = btn.dataset.variantId;
        if (!variantId) return;
        btn.disabled = true;
        btn.textContent = i18n.adding || '...';
        try {
          await addToCart(parseInt(variantId), 1);
          const cart = await fetchCart();
          renderCart(cart);
          showToast(i18n.added + ' 🛒');
        } catch (err) {
          showToast(i18n.errorAdd + ': ' + err.message);
          btn.disabled = false;
          btn.textContent = i18n.addToCart || 'Toevoegen';
        }
      });
    }

    // Kortingscode toggle
    const discountToggle = $('cf-discount-toggle');
    const discountField  = $('cf-discount-field');
    if (discountToggle && discountField) {
      discountToggle.addEventListener('click', () => {
        const isOpen = discountField.style.display !== 'none';
        discountField.style.display = isOpen ? 'none' : 'block';
        discountToggle.setAttribute('aria-expanded', String(!isOpen));
        if (!isOpen) $('cf-discount-input') && $('cf-discount-input').focus();
      });
    }

    // Kortingscode toepassen
    const applyBtn = $('cf-discount-apply');
    if (applyBtn) {
      applyBtn.addEventListener('click', handleDiscountApply);
    }
    const discountInput = $('cf-discount-input');
    if (discountInput) {
      discountInput.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') handleDiscountApply();
      });
    }

    // Kortingscode verwijderen (event delegation)
    const activeCodesEl = $('cf-discount-active-codes');
    if (activeCodesEl) {
      activeCodesEl.addEventListener('click', async (e) => {
        const btn = e.target.closest('.cf-discount__remove-code');
        if (!btn) return;
        await applyDiscount('');
        const cart = await fetchCart();
        renderCart(cart);
        showToast(i18n.discountRemoved);
      });
    }

    // Intercept Shopify add-to-cart forms (productpagina's)
    document.addEventListener('submit', handleFormSubmit);

    // Minimog custom event: cart:open
    document.addEventListener('cart:open', openDrawer);
    document.addEventListener('cf:cart:open', openDrawer);
  }

  async function handleItemAction(e) {
    const minusBtn  = e.target.closest('.cf-qty-minus');
    const plusBtn   = e.target.closest('.cf-qty-plus');
    const removeBtn = e.target.closest('.cf-cart-item__remove');

    if (!minusBtn && !plusBtn && !removeBtn) return;

    const key  = (minusBtn || plusBtn || removeBtn).dataset.key;
    const item = _cart && _cart.items.find(i => i.key === key);
    if (!item) return;

    const itemEl = e.target.closest('.cf-cart-item');
    if (itemEl) itemEl.classList.add('cf-cart-item--loading');

    let newQty;
    if (removeBtn) {
      newQty = 0;
    } else if (minusBtn) {
      newQty = item.quantity - 1;
    } else {
      newQty = item.quantity + 1;
    }

    // Debounce per item
    clearTimeout(_qtyDebounce[key]);
    _qtyDebounce[key] = setTimeout(async () => {
      try {
        await changeCartItem(key, newQty);
        const cart = await fetchCart();
        renderCart(cart);
      } catch (err) {
        showToast(err && err.stockFout && i18n.errorStock ? i18n.errorStock : i18n.errorQty);
        if (itemEl) itemEl.classList.remove('cf-cart-item--loading');
      }
    }, 300);
  }

  async function handleDiscountApply() {
    const input    = $('cf-discount-input');
    const feedback = $('cf-discount-feedback');
    if (!input || !feedback) return;

    const code = input.value.trim().toUpperCase();
    if (!code) return;

    const applyBtn = $('cf-discount-apply');
    if (applyBtn) { applyBtn.disabled = true; applyBtn.textContent = i18n.adding || '...'; }

    try {
      const cart = await applyDiscount(code);
      _cart = cart;

      // Controleer of code geldig is
      const applied = (cart.discount_codes || []).find(dc => dc.code.toUpperCase() === code);

      feedback.style.display = 'block';
      if (applied && applied.applicable) {
        feedback.className = 'cf-discount__feedback cf-feedback--success';
        feedback.textContent = unescapeStrong(i18n.discountApplied || 'Kortingscode "{{code}}" toegepast!').replace('{{code}}', code);
        input.value = '';
      } else {
        feedback.className = 'cf-discount__feedback cf-feedback--error';
        feedback.textContent = unescapeStrong(i18n.discountInvalid || 'Kortingscode "{{code}}" is niet geldig.').replace('{{code}}', code);
      }

      renderCart(cart);
    } catch (err) {
      feedback.style.display = 'block';
      feedback.className = 'cf-discount__feedback cf-feedback--error';
      feedback.textContent = i18n.errorGeneral || 'Er ging iets mis. Probeer het opnieuw.';
    } finally {
      if (applyBtn) { applyBtn.disabled = false; applyBtn.textContent = i18n.applying || 'Toepassen'; }
    }
  }

  async function handleFormSubmit(e) {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();

    const submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) { submitBtn.disabled = true; }

    try {
      const formData = new FormData(form);
      const variantId = formData.get('id');
      const qty       = parseInt(formData.get('quantity') || '1');
      const props     = {};
      formData.forEach((val, key) => {
        if (key.startsWith('properties[')) {
          const propKey = key.replace('properties[', '').replace(']', '');
          props[propKey] = val;
        }
      });

      await addToCart(variantId, qty, props);
      await openDrawer();
    } catch (err) {
      showToast('Kon product niet toevoegen: ' + err.message);
    } finally {
      if (submitBtn) submitBtn.disabled = false;
    }
  }

  // ─── CADEAU BIJ 50 EURO: ANTI-SNURK KIT OF DUO NASAL INHALER ───────────
  //
  // Regel 1 (bestaat als automatische korting "Gratis Anti-snurk kit vanaf 50 euro"):
  //   >= 50 euro aan de 11 snurkproducten  ->  gratis Anti-snurk kit
  // Regel 2 (tweede automatische korting, moet apart aangezet worden):
  //   >= 50 euro aan die 11 plus neusdouche/spoelzout  ->  gratis Duo Nasal Inhaler 2x
  //
  // De klant krijgt er altijd maar EEN. Zodra er een cadeau in de wagen ligt
  // verdwijnen alle "voeg toe"-knoppen en kan er alleen nog gewisseld worden.
  // Wisselen verwijdert eerst de oude regel en voegt daarna pas de nieuwe toe.

  // Drempel en maskercadeau komen uit window.cfCadeauConfig (snippets/cf-cart-drawer.liquid),
  // die ze uit het shop-metaveld custom.cf_cadeau_config leest. Zonder config: 50 euro, geen masker.
  var CF_CFG = window.cfCadeauConfig || {};
  // Bundels (29-10-2026): tellen voor de staffel als hun aantal onderdelen en krijgen zelf geen
  // staffelkorting, precies zoals de checkout-Function. Kaart variant-id -> aantal komt uit de snippet.
  var CF_BUNDELS = CF_CFG.bundels || {};
  function cfBundelN(item) { return (item && CF_BUNDELS[item.variant_id]) || 0; }
  function cfTelStuks(item) { var n = cfBundelN(item); return n ? n * item.quantity : item.quantity; }
  // Bedrag NA staffel (centen) van de regels waarvoor mee(regel) waar is; bundels tellen voor hun volle prijs.
  function cfNaStaffel(items, mee) {
    var pct = cfStaffelPct(items), los = 0, bundel = 0;
    items.forEach(function (i) {
      if (!mee(i)) return;
      if (cfBundelN(i)) bundel += i.original_line_price; else los += i.original_line_price;
    });
    return Math.round(los * (1 - pct / 100)) + bundel;
  }
  var CF_CADEAU_DREMPEL = cfNaarValuta(CF_CFG.drempel || 5000, true);

  // ── Vertalingen cadeau-blok (de/en/fr/da/nl) ─────────────────────────
  // CONFIG.locale komt uit snippets/cf-cart-drawer.liquid ({{ request.locale.iso_code }}),
  // dus dit volgt automatisch de storefront-taal. Nieuwe taal? Vul een blok bij;
  // zonder match valt alles terug op Nederlands. Productnamen gelijk aan de
  // productpagina-banner (snippets/cf-kit-cadeau.liquid). {naam}/{waarde}/{tekort}/
  // {rest}/{uitleg} worden door cfFmt ingevuld; {waarde} bevat al ' <twv> <prijs>'.
  var CF_CADEAU_LOCALE = (CONFIG.locale || 'nl').toLowerCase().substring(0, 2);
  var CF_CADEAU_T_ALL = {
    nl: {
      naam:   { kit: 'Anti-snurk kit', inhaler: 'Duo Nasal Inhaler 2x' },
      uitleg: { kit: 'anti-snurkproducten', inhaler: 'anti-snurk-, neusdouche- of spoelzoutproducten' },
      twv: 't.w.v.',
      bezig: 'Bezig...',
      tijdelijkUit: 'tijdelijk uitverkocht',
      kiesDe: 'Kies de {naam}',
      voegToe: 'Voeg mijn gratis {naam} toe',
      houdDe: 'Houd de {naam}',
      liever: 'Liever de {naam}? Wissel om',
      netUit: 'De {naam} is net uitverkocht. Kies het andere cadeau of probeer het later nog eens.',
      toevoegenMislukt: 'Toevoegen lukte niet. Ververs de pagina en probeer het opnieuw.',
      maarEen: 'Je kunt maar <strong>één</strong> cadeau kiezen. Welke wil je houden?',
      gratisToegevoegd: 'Gratis {naam} toegevoegd',
      nogNietGratis: 'Je <strong>{naam}</strong> is nog niet gratis. Nog <strong>{tekort}</strong> aan {uitleg} nodig.',
      cadeausOp: 'Je hebt een gratis cadeau verdiend, maar onze cadeaus zijn nu even op. We vullen snel aan.',
      gefeliciteerdKies: '<strong>Gefeliciteerd!</strong> Je hebt een gratis cadeau verdiend{waarde}. Kies er een:',
      anderUit: 'Het andere cadeau is nu uitverkocht.',
      gefeliciteerdEen: '<strong>Gefeliciteerd!</strong> Je hebt de gratis {naam}{waarde} verdiend.',
      nogTot: 'Nog <strong>{rest}</strong> tot een gratis cadeau{waarde}'
    },
    de: {
      naam:   { kit: 'Anti-Schnarch-Set', inhaler: 'Duo Nasal Inhaler 2x' },
      uitleg: { kit: 'Anti-Schnarch-Produkten', inhaler: 'Anti-Schnarch-, Nasendusche- oder Spülsalz-Produkten' },
      twv: 'im Wert von',
      bezig: 'Wird geladen...',
      tijdelijkUit: 'zurzeit ausverkauft',
      kiesDe: '{naam} wählen',
      voegToe: 'Mein gratis {naam} hinzufügen',
      houdDe: '{naam} behalten',
      liever: 'Lieber {naam}? Jetzt wechseln',
      netUit: '{naam} ist gerade ausverkauft. Wähle das andere Geschenk oder versuche es später noch einmal.',
      toevoegenMislukt: 'Hinzufügen fehlgeschlagen. Lade die Seite neu und versuche es erneut.',
      maarEen: 'Du kannst nur <strong>ein</strong> Geschenk wählen. Welches möchtest du behalten?',
      gratisToegevoegd: 'Gratis {naam} hinzugefügt',
      nogNietGratis: 'Dein <strong>{naam}</strong> ist noch nicht gratis. Noch <strong>{tekort}</strong> an {uitleg} nötig.',
      cadeausOp: 'Du hast ein gratis Geschenk verdient, aber unsere Geschenke sind gerade aus. Wir füllen bald nach.',
      gefeliciteerdKies: '<strong>Glückwunsch!</strong> Du hast ein gratis Geschenk verdient{waarde}. Wähle eines aus:',
      anderUit: 'Das andere Geschenk ist zurzeit ausverkauft.',
      gefeliciteerdEen: '<strong>Glückwunsch!</strong> Du hast dein gratis {naam}{waarde} verdient.',
      nogTot: 'Noch <strong>{rest}</strong> bis zum gratis Geschenk{waarde}'
    },
    en: {
      naam:   { kit: 'Anti-Snoring Kit', inhaler: 'Duo Nasal Inhaler 2x' },
      uitleg: { kit: 'anti-snoring products', inhaler: 'anti-snoring, nasal rinse or rinsing-salt products' },
      twv: 'worth',
      bezig: 'Working...',
      tijdelijkUit: 'temporarily sold out',
      kiesDe: 'Choose the {naam}',
      voegToe: 'Add my free {naam}',
      houdDe: 'Keep the {naam}',
      liever: 'Prefer the {naam}? Switch',
      netUit: 'The {naam} just sold out. Choose the other gift or try again later.',
      toevoegenMislukt: 'Could not add it. Refresh the page and try again.',
      maarEen: 'You can choose only <strong>one</strong> gift. Which would you like to keep?',
      gratisToegevoegd: 'Free {naam} added',
      nogNietGratis: 'Your <strong>{naam}</strong> isn\'t free yet. Add <strong>{tekort}</strong> more in {uitleg}.',
      cadeausOp: 'You\'ve earned a free gift, but our gifts are momentarily out of stock. We\'ll restock soon.',
      gefeliciteerdKies: '<strong>Congratulations!</strong> You\'ve earned a free gift{waarde}. Choose one:',
      anderUit: 'The other gift is currently sold out.',
      gefeliciteerdEen: '<strong>Congratulations!</strong> You\'ve earned the free {naam}{waarde}.',
      nogTot: '<strong>{rest}</strong> more for a free gift{waarde}'
    },
    fr: {
      naam:   { kit: 'Kit anti-ronflement', inhaler: 'Duo Nasal Inhaler 2x' },
      uitleg: { kit: 'produits anti-ronflement', inhaler: 'produits anti-ronflement, de douche nasale ou de sel de rinçage' },
      twv: 'd\'une valeur de',
      bezig: 'En cours...',
      tijdelijkUit: 'temporairement épuisé',
      kiesDe: 'Choisir le {naam}',
      voegToe: 'Ajouter mon {naam} offert',
      houdDe: 'Garder le {naam}',
      liever: 'Vous préférez le {naam} ? Changer',
      netUit: 'Le {naam} vient de s\'épuiser. Choisissez l\'autre cadeau ou réessayez plus tard.',
      toevoegenMislukt: 'L\'ajout a échoué. Actualisez la page et réessayez.',
      maarEen: 'Vous ne pouvez choisir qu\'<strong>un</strong> cadeau. Lequel souhaitez-vous garder ?',
      gratisToegevoegd: '{naam} offert ajouté',
      nogNietGratis: 'Votre <strong>{naam}</strong> n\'est pas encore offert. Encore <strong>{tekort}</strong> en {uitleg}.',
      cadeausOp: 'Vous avez gagné un cadeau gratuit, mais nos cadeaux sont momentanément épuisés. Réapprovisionnement bientôt.',
      gefeliciteerdKies: '<strong>Félicitations !</strong> Vous avez gagné un cadeau gratuit{waarde}. Choisissez-en un :',
      anderUit: 'L\'autre cadeau est actuellement épuisé.',
      gefeliciteerdEen: '<strong>Félicitations !</strong> Vous avez gagné le {naam} gratuit{waarde}.',
      nogTot: 'Encore <strong>{rest}</strong> pour un cadeau gratuit{waarde}'
    },
    da: {
      naam:   { kit: 'anti-snorke-sæt', inhaler: 'Duo Nasal Inhaler 2x' },
      uitleg: { kit: 'anti-snorke-produkter', inhaler: 'anti-snorke-, næseskyl- eller skyllesaltprodukter' },
      twv: 'til en værdi af',
      bezig: 'Arbejder...',
      tijdelijkUit: 'midlertidigt udsolgt',
      kiesDe: 'Vælg {naam}',
      voegToe: 'Tilføj gratis {naam}',
      houdDe: 'Behold {naam}',
      liever: 'Vil du hellere have {naam}? Skift',
      netUit: '{naam} er lige udsolgt. Vælg den anden gave, eller prøv igen senere.',
      toevoegenMislukt: 'Tilføjelsen mislykkedes. Genindlæs siden, og prøv igen.',
      maarEen: 'Du kan kun vælge <strong>én</strong> gave. Hvilken vil du beholde?',
      gratisToegevoegd: 'Gratis {naam} tilføjet',
      nogNietGratis: '<strong>{naam}</strong> er endnu ikke gratis. Der mangler <strong>{tekort}</strong> i {uitleg}.',
      cadeausOp: 'Du har optjent en gratis gave, men vores gaver er lige nu udsolgt. Vi fylder snart op.',
      gefeliciteerdKies: '<strong>Tillykke!</strong> Du har optjent en gratis gave{waarde}. Vælg en:',
      anderUit: 'Den anden gave er i øjeblikket udsolgt.',
      gefeliciteerdEen: '<strong>Tillykke!</strong> Du har optjent {naam} gratis{waarde}.',
      nogTot: 'Kun <strong>{rest}</strong> til en gratis gave{waarde}'
    }
  };
  var CFT = CF_CADEAU_T_ALL[CF_CADEAU_LOCALE] || CF_CADEAU_T_ALL.nl;
  function cfFmt(tmpl, vars) {
    return String(tmpl).replace(/\{(\w+)\}/g, function (m, k) {
      return (vars && vars[k] != null) ? vars[k] : '';
    });
  }
  function cfNaam(cadeau)   { return (CFT.naam && CFT.naam[cadeau.key]) || cadeau.naam; }
  function cfUitleg(cadeau) { return (CFT.uitleg && CFT.uitleg[cadeau.key]) || cadeau.uitleg; }

  // De 11 producten van de bestaande kit-korting
  var CF_SNURK_IDS = (window.cfCadeauIds && window.cfCadeauIds.snurk && window.cfCadeauIds.snurk.length)
    ? window.cfCadeauIds.snurk
    : [8216809210167, 8216826741047, 10092585025870, 10387535626574,
       10387551617358, 10387639828814, 10387664142670, 10440974991694, 10623650169166,
       10624140214606, 15837342630222,
       16202686529870, 16202686759246, 16222647025998, 16222647386446]; // + bundels met tag cadeau-snurk (Neus & Mond, magnetisch, neusstrips 50 + mondtape)

  // Neusdouche en spoelzout, tellen alleen mee voor de inhaler
  var CF_SPOEL_IDS = (window.cfCadeauIds && window.cfCadeauIds.inhaler && window.cfCadeauIds.inhaler.length)
    ? window.cfCadeauIds.inhaler
    : [8764440019278, 10622441423182, 15934078976334, 10824854405454, 16202686923086]; // + neusdouche-bundel (tag cadeau-inhaler)

  var CF_CADEAUS = [
    {
      key: 'kit',
      variant: 44952024154423,
      naam: 'Anti-snurk kit',
      telt: CF_SNURK_IDS,
      uitleg: 'anti-snurkproducten'
    },
    {
      key: 'inhaler',
      variant: 59189325365582,
      naam: 'Duo Nasal Inhaler 2x',
      telt: CF_SNURK_IDS.concat(CF_SPOEL_IDS),
      uitleg: 'anti-snurk-, neusdouche- of spoelzoutproducten'
    }
  ];

  // Variants die tijdens deze sessie uitverkocht bleken (add.js gaf een fout)
  var cfCadeauUit = {};
  var cfCadeauEl = null;
  var cfCadeauLaatsteRegels = [];
  var cfCadeauFoutTekst = '';

  // Met valutateken. In euro precies als voorheen (&euro;11,01), anders bijv. "82,00 kr.".
  function cfCadeauBedrag(cents) {
    if (cfValuta() !== 'EUR') return formatMoney(cents);
    return '&euro;' + (cents / 100).toFixed(2).replace('.', ',');
  }

  // Voorraad en prijs komen uit snippets/cf-cart-drawer.liquid, die ze
  // rechtstreeks uit het product leest. Nergens een prijs vastzetten.
  function cfCadeauInfo(cadeau) {
    var lijst = window.cfCadeauInfo;
    return (lijst && lijst[cadeau.variant]) || null;
  }

  function cfCadeauOpVoorraad(cadeau) {
    if (cfCadeauUit[cadeau.variant]) return false;
    var info = cfCadeauInfo(cadeau);
    if (!info || typeof info.op === 'undefined') return true; // onbekend: laat de knop staan, add.js vangt het af
    return info.op > 0;
  }

  // " t.w.v. EUR 12,99", of leeg als de prijs onbekend is
  function cfCadeauWaarde(cadeau) {
    var info = cfCadeauInfo(cadeau);
    return info && info.prijs ? ' ' + CFT.twv + ' ' + info.prijs : '';
  }

  // Waarde die voor beide cadeaus geldt, of leeg als ze verschillen
  function cfCadeauWaardeSamen(lijst) {
    var eerste = cfCadeauWaarde(lijst[0]);
    for (var i = 1; i < lijst.length; i++) {
      if (cfCadeauWaarde(lijst[i]) !== eerste) return '';
    }
    return eerste;
  }

  function cfCadeauIsCadeauregel(item) {
    if (cfIsMaskerCadeau(item)) return true;
    for (var i = 0; i < CF_CADEAUS.length; i++) {
      if (item.variant_id === CF_CADEAUS[i].variant) return true;
    }
    return false;
  }

  // Staffelpercentage op het aantal betaalde (niet-cadeau) artikelen. Gelijk aan
  // de checkout-Function, zodat thema en afrekenen exact hetzelfde beslissen.
  // Bundels in de wagen (29-10): de set heeft al een eigen prijs en krijgt zelf geen staffel. Liggen er
  // alleen sets in de wagen, dan zegt de balk dat ANDERE producten nu de korting krijgen.
  var CFSET_ALL = {
    nl: { alleen: 'Je set telt mee voor de staffel: andere producten krijgen nu <strong>{p}% korting</strong>.', noot: ' Sets hebben al hun eigen setprijs.' },
    de: { alleen: 'Dein Set zählt für den Mengenrabatt: andere Produkte erhalten jetzt <strong>{p}% Rabatt</strong>.', noot: ' Sets haben bereits ihren eigenen Setpreis.' },
    en: { alleen: 'Your set counts towards the volume discount: other products now get <strong>{p}% off</strong>.', noot: ' Sets already have their own set price.' },
    fr: { alleen: 'Votre coffret compte pour la remise quantité : les autres produits ont maintenant <strong>{p}% de remise</strong>.', noot: ' Les coffrets ont déjà leur propre prix.' },
    da: { alleen: 'Dit sæt tæller med i mængderabatten: andre produkter får nu <strong>{p}% rabat</strong>.', noot: ' Sæt har allerede deres egen sætpris.' }
  };
  function cfBundelStaffelTekst(items) {
    var msgEl = $('cf-reward-message');
    if (!msgEl || !items) return;
    var bundel = 0, los = 0;
    items.forEach(function (i) {
      if (cfCadeauIsCadeauregel(i)) return;
      if (cfBundelN(i)) bundel += i.quantity; else los += i.quantity;
    });
    var pct = cfStaffelPct(items);
    if (!bundel || !pct) return;
    var T = CFSET_ALL[CF_CADEAU_LOCALE] || CFSET_ALL.nl;
    if (!los) msgEl.innerHTML = cfFmt(T.alleen, { p: pct });
    else msgEl.innerHTML = msgEl.innerHTML + T.noot;
  }

  function cfStaffelPct(items) {
    var qty = 0;
    for (var i = 0; i < items.length; i++) {
      if (!cfCadeauIsCadeauregel(items[i])) qty += cfTelStuks(items[i]);
    }
    var pct = 0;
    for (var t = 0; t < REWARD_TIERS.length; t++) {
      if (qty >= REWARD_TIERS[t].minItems) pct = REWARD_TIERS[t].discount;
    }
    return pct;
  }

  function cfCadeauSom(cadeau, items) {
    // Bedrag van de kwalificerende producten NA de staffelkorting (in centen).
    // De cadeaudrempel geldt op wat de klant werkelijk betaalt, net als de Function.
    // Het cadeau telt niet mee voor zijn eigen drempel; bundels voor hun volle prijs (geen staffel).
    return cfNaStaffel(items, function (item) {
      return !cfCadeauIsCadeauregel(item) && cadeau.telt.indexOf(item.product_id) > -1;
    });
  }

  function cfCadeauZoek(key) {
    for (var i = 0; i < CF_CADEAUS.length; i++) {
      if (CF_CADEAUS[i].key === key) return CF_CADEAUS[i];
    }
    return null;
  }

  function cfCadeauKnopHtml(cadeau, klaar) {
    if (!cfCadeauOpVoorraad(cadeau)) {
      return '<button type="button" disabled>' + cfNaam(cadeau) + ' &middot; ' + CFT.tijdelijkUit + '</button>';
    }
    return '<button type="button" data-cadeau-add="' + cadeau.key + '">' +
      (klaar || cfFmt(CFT.kiesDe, { naam: cfNaam(cadeau) })) + '</button>';
  }

  // Houdt een cadeau over en ruimt alle andere cadeauregels op.
  // In een keer via /cart/update.js: los per regel wijzigen laat Shopify de
  // overige regelsleutels opnieuw uitdelen en dan mist de tweede wijziging.
  function cfCadeauHoud(knop, cadeauRegels) {
    var houd = knop.getAttribute('data-cadeau-houd');
    knop.disabled = true;
    knop.innerHTML = CFT.bezig;
    var updates = {};
    var alGehouden = false;
    cadeauRegels.forEach(function (c) {
      var naar = 0;
      if (c.cadeau.key === houd && !alGehouden) { naar = 1; alGehouden = true; }
      updates[c.regel.key] = naar;
    });
    fetch('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function () {
      return fetchCart().then(function (nieuweCart) { renderCart(nieuweCart); });
    }).catch(function () {
      fetchCart().then(renderCart).catch(function () {});
    });
  }

  function cfCadeauActie(knop) {
    var cadeau = cfCadeauZoek(knop.getAttribute('data-cadeau-add') || knop.getAttribute('data-cadeau-wissel'));
    if (!cadeau) return;
    var wisselKey = knop.getAttribute('data-cadeau-verwijder');
    var oud = knop.innerHTML;
    knop.disabled = true;
    knop.innerHTML = CFT.bezig;
    cfCadeauFoutTekst = '';

    var stap = wisselKey
      ? fetch('/cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: wisselKey, quantity: 0 })
        })
      : Promise.resolve(null);

    stap.then(function () {
      return fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: cadeau.variant, quantity: 1 }] })
      });
    }).then(function (res) {
      if (!res.ok) {
        return res.json().catch(function () { return {}; }).then(function (data) {
          var fout = new Error('add mislukt');
          fout.shopify = data;
          throw fout;
        });
      }
      return null;
    }).then(function () {
      return fetchCart().then(function (nieuweCart) {
        renderCart(nieuweCart);
        openDrawer();
      });
    }).catch(function (fout) {
      // Meestal: cadeau net uitverkocht. Zet hem op uit zodat de knop niet
      // opnieuw stilletjes faalt, en vertel de klant wat er aan de hand is.
      cfCadeauUit[cadeau.variant] = true;
      var melding = fout && fout.shopify && fout.shopify.description;
      cfCadeauFoutTekst = melding
        ? cfFmt(CFT.netUit, { naam: cfNaam(cadeau) })
        : CFT.toevoegenMislukt;
      knop.disabled = false;
      knop.innerHTML = oud;
      fetchCart().then(renderCart).catch(function () {});
    });
  }

  function renderKitCadeau(cart, itemsEl) {
    var el = document.getElementById('cfKitCadeau');
    if (!el) {
      if (!itemsEl || !itemsEl.parentNode) return;
      el = document.createElement('div');
      el.id = 'cfKitCadeau';
      itemsEl.parentNode.insertBefore(el, itemsEl);
      var stijl = document.createElement('style');
      stijl.textContent = '#cfKitCadeau{margin:0 0 10px;font-size:13px;line-height:1.5;color:#003d63}' +
        '#cfKitCadeau .cfkit{padding:9px 12px;border-radius:8px;background:rgba(232,112,58,0.10)}' +
        '#cfKitCadeau .cfkit--klaar{background:rgba(46,160,67,0.12);color:#1f7a33;font-weight:600}' +
        '#cfKitCadeau .cfkit--let-op{background:rgba(214,145,20,0.14);color:#8a5a00}' +
        '#cfKitCadeau .cfkit__keuze{display:flex;flex-direction:column;gap:6px;margin-top:8px}' +
        '#cfKitCadeau button{padding:8px 14px;border:0;border-radius:8px;background:#E8703A;color:#fff;font-weight:700;font-size:13px;cursor:pointer;width:100%}' +
        '#cfKitCadeau button[disabled]{opacity:.5;cursor:not-allowed}' +
        '#cfKitCadeau .cfkit__wissel{margin-top:6px;background:transparent;color:#003d63;border:1px solid rgba(0,61,99,.35);font-weight:600}' +
        '#cfKitCadeau .cfkit__fout{margin:6px 0 0;color:#b3261e;font-weight:600}' +
        '#cfKitCadeau .cfkit__op{margin:6px 0 0;opacity:.75}';
      document.head.appendChild(stijl);
      el.addEventListener('click', function (e) {
        var knop = e.target.closest('[data-cadeau-add],[data-cadeau-wissel],[data-cadeau-houd]');
        if (!knop || knop.disabled) return;
        if (knop.hasAttribute('data-cadeau-houd')) {
          cfCadeauHoud(knop, cfCadeauLaatsteRegels);
        } else {
          cfCadeauActie(knop);
        }
      });
    }
    cfCadeauEl = el;
    // Duitsland (28-10): geen kit/inhaler-cadeau (HWG par. 7), dus ook geen cadeaublok.
    if (CF_CFG.kitUit) { el.innerHTML = ''; return; }

    var items = (cart && cart.items) || [];

    // Alle cadeauregels in de wagen (normaal precies nul of een)
    var cadeauRegels = [];
    for (var i = 0; i < items.length; i++) {
      for (var j = 0; j < CF_CADEAUS.length; j++) {
        if (items[i].variant_id === CF_CADEAUS[j].variant) {
          cadeauRegels.push({ cadeau: CF_CADEAUS[j], regel: items[i] });
        }
      }
    }
    var inWagen = cadeauRegels.length ? cadeauRegels[0] : null;
    cfCadeauLaatsteRegels = cadeauRegels;

    var kit = CF_CADEAUS[0];
    var inh = CF_CADEAUS[1];
    var somKit = cfCadeauSom(kit, items);
    var somInh = cfCadeauSom(inh, items);
    var haalt = {};
    haalt[kit.key] = somKit >= CF_CADEAU_DREMPEL;
    haalt[inh.key] = somInh >= CF_CADEAU_DREMPEL;

    // Niets relevants in de wagen en geen cadeau: helemaal niets tonen
    if (!inWagen && somInh === 0) { el.hidden = true; el.innerHTML = ''; return; }
    el.hidden = false;

    var fout = cfCadeauFoutTekst ? '<p class="cfkit__fout">' + cfCadeauFoutTekst + '</p>' : '';

    // ── Vangnet: meer dan een cadeau, of meer dan een stuks ──────────────
    // Kan gebeuren als iemand een cadeau rechtstreeks via de productpagina
    // toevoegt. Met twee actieve kortingsregels zouden ze allebei kunnen slaan.
    var cadeauStuks = cadeauRegels.reduce(function (n, c) { return n + c.regel.quantity; }, 0);
    var teVeel = cadeauStuks > 1;
    if (teVeel) {
      var gezien = {};
      var houdKnoppen = cadeauRegels.filter(function (c) {
        if (gezien[c.cadeau.key]) return false;
        gezien[c.cadeau.key] = true;
        return true;
      }).map(function (c) {
        return '<button type="button" data-cadeau-houd="' + c.cadeau.key + '">' + cfFmt(CFT.houdDe, { naam: cfNaam(c.cadeau) }) + '</button>';
      }).join('');
      el.innerHTML = '<div class="cfkit cfkit--let-op">&#9888; ' + CFT.maarEen +
        '<div class="cfkit__keuze">' + houdKnoppen + '</div></div>' + fout;
      return;
    }

    // ── Er ligt al een cadeau in de wagen ────────────────────────────────
    if (inWagen) {
      cfCadeauFoutTekst = ''; // er ligt een cadeau in de wagen, oude foutmelding is niet meer relevant
      fout = '';
      var dit = inWagen.cadeau;
      var ander = dit === kit ? inh : kit;
      var mag = haalt[dit.key];
      var anderMag = haalt[ander.key] && cfCadeauOpVoorraad(ander);
      var wisselKnop = anderMag
        ? '<button type="button" class="cfkit__wissel" data-cadeau-wissel="' + ander.key +
          '" data-cadeau-verwijder="' + inWagen.regel.key + '">' + cfFmt(CFT.liever, { naam: cfNaam(ander) }) + '</button>'
        : '';

      if (mag) {
        el.innerHTML = '<div class="cfkit cfkit--klaar">&#10003; ' +
          cfFmt(CFT.gratisToegevoegd, { naam: cfNaam(dit) }) + wisselKnop + '</div>' + fout;
      } else {
        var tekort = cfCadeauBedrag(CF_CADEAU_DREMPEL - cfCadeauSom(dit, items));
        el.innerHTML = '<div class="cfkit cfkit--let-op">&#9888; ' +
          cfFmt(CFT.nogNietGratis, { naam: cfNaam(dit), tekort: tekort, uitleg: cfUitleg(dit) }) +
          wisselKnop + '</div>' + fout;
      }
      return;
    }

    // ── Nog geen cadeau in de wagen ──────────────────────────────────────
    var keuze = CF_CADEAUS.filter(function (c) { return haalt[c.key]; });
    var leverbaar = keuze.filter(cfCadeauOpVoorraad);

    if (keuze.length && !leverbaar.length) {
      el.innerHTML = '<div class="cfkit">&#127873; ' + CFT.cadeausOp + '</div>' + fout;
      return;
    }

    if (leverbaar.length > 1) {
      el.innerHTML = '<div class="cfkit">&#127873; ' +
        cfFmt(CFT.gefeliciteerdKies, { waarde: cfCadeauWaardeSamen(leverbaar) }) +
        '<div class="cfkit__keuze">' + leverbaar.map(function (c) { return cfCadeauKnopHtml(c); }).join('') + '</div>' +
        '</div>' + fout;
      return;
    }

    if (leverbaar.length === 1) {
      var enige = leverbaar[0];
      var opTekst = keuze.length > 1
        ? '<p class="cfkit__op">' + CFT.anderUit + '</p>'
        : '';
      el.innerHTML = '<div class="cfkit">&#127873; ' +
        cfFmt(CFT.gefeliciteerdEen, { naam: cfNaam(enige), waarde: cfCadeauWaarde(enige) }) + opTekst +
        '<div class="cfkit__keuze">' + cfCadeauKnopHtml(enige, cfFmt(CFT.voegToe, { naam: cfNaam(enige) })) + '</div>' +
        '</div>' + fout;
      return;
    }

    // Nog onder de drempel. De inhalerlijst is de ruimste, dus die bepaalt
    // hoeveel er nog bij moet voor minimaal een cadeau.
    var rest = cfCadeauBedrag(CF_CADEAU_DREMPEL - somInh);
    el.innerHTML = '<div class="cfkit">&#127873; ' +
      cfFmt(CFT.nogTot, { rest: rest, waarde: cfCadeauWaardeSamen(CF_CADEAUS) }) + '</div>' + fout;
  }

  // ─── GRATIS COLLAGEEN MASKER (geel of groen) ──────────────────────────────
  //
  // Nieuw 26-10-2026, staat aan/uit via window.cfCadeauConfig.masker (shop-metaveld).
  // Gratis zodra alle betaalde artikelen NA staffel >= masker.drempel zijn, of als er
  // collageen mondtape in de wagen ligt. De klant kiest Calm Balance (groen) of Glow
  // Boost (geel). Het cadeau is een gewone maskerregel met het verborgen regelkenmerk
  // _cf_cadeau = "masker"; de Function maakt precies een stuk daarvan gratis. Een masker
  // zonder dat kenmerk is gewoon betaald.

  var CF_MASKER = (CF_CFG.masker && CF_CFG.masker.aan) ? CF_CFG.masker : null;
  if (CF_MASKER) CF_MASKER = Object.assign({}, CF_MASKER, { drempel: cfNaarValuta(CF_MASKER.drempel || 0, true) });
  var CFM_ALL = {
    nl: {
      kiesCollageen: '<strong>Cadeau bij je collageen aankoop!</strong> Kies een gratis collageen masker{waarde}:',
      hoortBij: 'Het gratis masker hoort bij een collageen masker of de collageen mondtape.',
      label: 'Gratis cadeau',
      naam: { groen: 'Calm Balance (groen)', geel: 'Glow Boost (geel)' },
      twv: 't.w.v.',
      nogTot: 'Nog <strong>{rest}</strong> aan collageenproducten tot een gratis collageen masker{waarde}',
      kies: '<strong>Gefeliciteerd!</strong> Je krijgt een gratis collageen masker{waarde}. Kies je favoriet:',
      kiesMondtape: '<strong>Bij je collageen mondtape:</strong> een gratis collageen masker{waarde}. Kies je favoriet:',
      toegevoegd: 'Gratis collageen masker {naam} toegevoegd',
      liever: 'Liever {naam}? Wissel om',
      nogNiet: 'Je collageen masker is nog niet gratis. Nog <strong>{tekort}</strong> aan collageenproducten nodig.',
      op: 'Je krijgt een gratis collageen masker, maar ze zijn nu even op. We vullen snel aan.',
      bezig: 'Bezig...',
      mislukt: 'Toevoegen lukte niet. Ververs de pagina en probeer het opnieuw.'
    },
    de: {
      kiesCollageen: '<strong>Geschenk zu deinem Kollagen-Kauf!</strong> Wähle eine gratis Kollagen-Maske{waarde}:',
      hoortBij: 'Die gratis Maske gibt es zu einer Kollagen-Maske oder dem Kollagen-Mundtape.',
      label: 'Gratis Geschenk',
      naam: { groen: 'Calm Balance (grün)', geel: 'Glow Boost (gelb)' },
      twv: 'im Wert von',
      nogTot: 'Noch <strong>{rest}</strong> an Kollagen-Produkten bis zur gratis Kollagen-Maske{waarde}',
      kies: '<strong>Glückwunsch!</strong> Du bekommst eine gratis Kollagen-Maske{waarde}. Wähle deinen Favoriten:',
      kiesMondtape: '<strong>Zu deinem Kollagen-Mundtape:</strong> eine gratis Kollagen-Maske{waarde}. Wähle deinen Favoriten:',
      toegevoegd: 'Gratis Kollagen-Maske {naam} hinzugefügt',
      liever: 'Lieber {naam}? Jetzt wechseln',
      nogNiet: 'Deine Kollagen-Maske ist noch nicht gratis. Noch <strong>{tekort}</strong> an Kollagen-Produkten nötig.',
      op: 'Du bekommst eine gratis Kollagen-Maske, aber sie sind gerade aus. Wir füllen bald nach.',
      bezig: 'Wird geladen...',
      mislukt: 'Hinzufügen fehlgeschlagen. Lade die Seite neu und versuche es erneut.'
    },
    en: {
      kiesCollageen: '<strong>A gift with your collagen purchase!</strong> Choose a free collagen mask{waarde}:',
      hoortBij: 'The free mask comes with a collagen mask or the collagen mouth tape.',
      label: 'Free gift',
      naam: { groen: 'Calm Balance (green)', geel: 'Glow Boost (yellow)' },
      twv: 'worth',
      nogTot: '<strong>{rest}</strong> more in collagen products for a free collagen mask{waarde}',
      kies: '<strong>Congratulations!</strong> You get a free collagen mask{waarde}. Pick your favourite:',
      kiesMondtape: '<strong>With your collagen mouth tape:</strong> a free collagen mask{waarde}. Pick your favourite:',
      toegevoegd: 'Free collagen mask {naam} added',
      liever: 'Prefer {naam}? Switch',
      nogNiet: 'Your collagen mask isn\'t free yet. Add <strong>{tekort}</strong> more in collagen products.',
      op: 'You get a free collagen mask, but they are momentarily out of stock. We\'ll restock soon.',
      bezig: 'Working...',
      mislukt: 'Could not add it. Refresh the page and try again.'
    },
    fr: {
      kiesCollageen: '<strong>Un cadeau avec votre achat au collagène !</strong> Choisissez un masque au collagène offert{waarde} :',
      hoortBij: 'Le masque offert accompagne un masque au collagène ou les bandelettes buccales au collagène.',
      label: 'Cadeau offert',
      naam: { groen: 'Calm Balance (vert)', geel: 'Glow Boost (jaune)' },
      twv: 'd\'une valeur de',
      nogTot: 'Encore <strong>{rest}</strong> en produits au collagène pour un masque au collagène offert{waarde}',
      kies: '<strong>Félicitations !</strong> Un masque au collagène vous est offert{waarde}. Choisissez votre préféré :',
      kiesMondtape: '<strong>Avec vos bandelettes buccales au collagène :</strong> un masque au collagène offert{waarde}. Choisissez votre préféré :',
      toegevoegd: 'Masque au collagène {naam} offert ajouté',
      liever: 'Vous préférez {naam} ? Changer',
      nogNiet: 'Votre masque au collagène n\'est pas encore offert. Encore <strong>{tekort}</strong> en produits au collagène.',
      op: 'Un masque au collagène vous est offert, mais ils sont momentanément épuisés. Réapprovisionnement bientôt.',
      bezig: 'En cours...',
      mislukt: 'L\'ajout a échoué. Actualisez la page et réessayez.'
    },
    da: {
      kiesCollageen: '<strong>En gave til dit kollagenkøb!</strong> Vælg en gratis kollagenmaske{waarde}:',
      hoortBij: 'Den gratis maske følger med en kollagenmaske eller kollagen-mundtapen.',
      label: 'Gratis gave',
      naam: { groen: 'Calm Balance (grøn)', geel: 'Glow Boost (gul)' },
      twv: 'til en værdi af',
      nogTot: 'Kun <strong>{rest}</strong> i kollagenprodukter til en gratis kollagenmaske{waarde}',
      kies: '<strong>Tillykke!</strong> Du får en gratis kollagenmaske{waarde}. Vælg din favorit:',
      kiesMondtape: '<strong>Til din kollagen-mundtape:</strong> en gratis kollagenmaske{waarde}. Vælg din favorit:',
      toegevoegd: 'Gratis kollagenmaske {naam} tilføjet',
      liever: 'Hellere {naam}? Skift',
      nogNiet: 'Din kollagenmaske er endnu ikke gratis. Der mangler <strong>{tekort}</strong> i kollagenprodukter.',
      op: 'Du får en gratis kollagenmaske, men de er lige nu udsolgt. Vi fylder snart op.',
      bezig: 'Arbejder...',
      mislukt: 'Tilføjelsen mislykkedes. Genindlæs siden, og prøv igen.'
    }
  };
  var CFM = CFM_ALL[CF_CADEAU_LOCALE] || CFM_ALL.nl;
  var cfMaskerUit = {};
  var cfMaskerFout = '';

  function cfIsMaskerCadeau(item) {
    return !!(item && item.properties && item.properties._cf_cadeau === 'masker');
  }

  // Aantal echt betaalde artikelen: cadeauregels (kit, inhaler, masker) tellen niet mee.
  function cfBetaaldAantal(items) {
    var n = 0;
    (items || []).forEach(function (i) { if (!cfCadeauIsCadeauregel(i)) n += cfTelStuks(i); });
    return n;
  }

  function cfMaskerVarianten() {
    return ((CF_MASKER && CF_MASKER.varianten) || []).filter(function (v) { return v && v.variant; });
  }

  function cfMaskerOpVoorraad(v) {
    return !cfMaskerUit[v.variant] && v.op !== 0;
  }

  // Bedrag van alle betaalde artikelen NA staffel (centen), abonnementen niet, net als de Function.
  function cfMaskerSom(items) {
    return cfNaStaffel(items, function (i) { return !cfCadeauIsCadeauregel(i) && !i.selling_plan_allocation; });
  }

  // Ligt er een betaald collageenproduct in de wagen (roze/groen/geel masker of collageen mondtape)?
  function cfMaskerMetCollageen(items) {
    var ids = (CF_MASKER && CF_MASKER.collageen) || [];
    return items.some(function (i) {
      return !cfCadeauIsCadeauregel(i) && !i.selling_plan_allocation && ids.indexOf(i.product_id) > -1;
    });
  }

  // Bedrag van de betaalde collageenproducten NA staffel (centen). Met een maskerdrempel
  // (David 27-10: 30 euro) telt alleen dit bedrag, net als in de Function.
  function cfMaskerCollageenSom(items) {
    var ids = (CF_MASKER && CF_MASKER.collageen) || [];
    return cfNaStaffel(items, function (i) {
      return !cfCadeauIsCadeauregel(i) && !i.selling_plan_allocation && ids.indexOf(i.product_id) > -1;
    });
  }

  function cfMaskerWaarde() {
    var v = cfMaskerVarianten()[0];
    return v && v.prijs ? ' ' + CFM.twv + ' ' + v.prijs : '';
  }

  function cfMaskerKnop(v, wisselKey) {
    if (!cfMaskerOpVoorraad(v)) return '';
    var tekst = wisselKey ? cfFmt(CFM.liever, { naam: CFM.naam[v.key] || v.key }) : (CFM.naam[v.key] || v.key);
    return '<button type="button"' + (wisselKey ? ' class="cfkit__wissel"' : '') +
      ' data-masker-add="' + v.variant + '"' + (wisselKey ? ' data-masker-weg="' + wisselKey + '"' : '') + '>' + tekst + '</button>';
  }

  function cfMaskerActie(knop) {
    var variant = parseInt(knop.getAttribute('data-masker-add'), 10);
    var weg = knop.getAttribute('data-masker-weg');
    knop.disabled = true;
    knop.innerHTML = CFM.bezig;
    cfMaskerFout = '';
    var stap = weg
      ? fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: weg, quantity: 0 }) })
      : Promise.resolve(null);
    stap.then(function () {
      return fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variant, quantity: 1, properties: { _cf_cadeau: 'masker' } }] })
      });
    }).then(function (res) {
      if (!res.ok) throw new Error('add mislukt');
      return fetchCart().then(function (c) { renderCart(c); openDrawer(); });
    }).catch(function () {
      cfMaskerUit[variant] = true;
      cfMaskerFout = CFM.mislukt;
      fetchCart().then(renderCart).catch(function () {});
    });
  }

  // ─── TRIO-SET TIP (29-10-2026) ─────────────────────────────────────────────
  // Ligt er van elke maskerkleur (roze, groen, geel) minstens een betaalde doos in de wagen, dan is
  // de Trio-set goedkoper. De knop ruilt per volledige set drie losse dozen om voor de set.
  var CF_TRIO = (CF_CFG.trio && CF_CFG.trio.variant) ? CF_CFG.trio : null;
  var CFTRIO_ALL = {
    nl: { tip: '<strong>Tip:</strong> 1 doos van elke kleur is als Trio-set maar {prijs}.', knop: 'Omwisselen naar Trio-set', bezig: 'Bezig...' },
    de: { tip: '<strong>Tipp:</strong> Je eine Packung jeder Sorte gibt es als Trio-Set für nur {prijs}.', knop: 'Gegen Trio-Set tauschen', bezig: 'Wird geladen...' },
    en: { tip: '<strong>Tip:</strong> one box of each colour is only {prijs} as a Trio set.', knop: 'Switch to the Trio set', bezig: 'Working...' },
    fr: { tip: '<strong>Astuce :</strong> une boîte de chaque couleur ne coûte que {prijs} en coffret Trio.', knop: 'Passer au coffret Trio', bezig: 'En cours...' },
    da: { tip: '<strong>Tip:</strong> én æske af hver farve koster kun {prijs} som Trio-sæt.', knop: 'Skift til Trio-sæt', bezig: 'Arbejder...' }
  };
  var CFTRIO = CFTRIO_ALL[CF_CADEAU_LOCALE] || CFTRIO_ALL.nl;

  function cfTrioRegels(items) {
    var per = CF_TRIO.los.map(function (v) {
      return (items || []).filter(function (i) {
        return i.variant_id === v && !cfCadeauIsCadeauregel(i) && !i.selling_plan_allocation;
      });
    });
    var sets = Math.min.apply(null, per.map(function (r) { return r.reduce(function (n, i) { return n + i.quantity; }, 0); }));
    return { per: per, sets: sets };
  }

  function cfTrioWissel(knop) {
    knop.disabled = true;
    knop.innerHTML = CFTRIO.bezig;
    fetchCart().then(function (c) {
      var t = cfTrioRegels(c.items);
      if (!t.sets) return null;
      var updates = {};
      t.per.forEach(function (regels) {
        var weg = t.sets;
        regels.forEach(function (r) {
          if (!weg) return;
          var af = Math.min(weg, r.quantity);
          updates[r.key] = r.quantity - af;
          weg -= af;
        });
      });
      return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) })
        .then(function () {
          return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: CF_TRIO.variant, quantity: t.sets }] }) });
        });
    }).then(function () {
      return fetchCart().then(function (c) { renderCart(c); openDrawer(); });
    }).catch(function () {
      fetchCart().then(renderCart).catch(function () {});
    });
  }

  function renderTrioTip(cart, itemsEl) {
    var el = document.getElementById('cfTrioTip');
    var sets = CF_TRIO ? cfTrioRegels((cart && cart.items) || []).sets : 0;
    if (!sets) { if (el) { el.hidden = true; el.innerHTML = ''; } return; }
    if (!el) {
      if (!itemsEl || !itemsEl.parentNode) return;
      el = document.createElement('div');
      el.id = 'cfTrioTip';
      itemsEl.parentNode.insertBefore(el, itemsEl);
      var stijl = document.createElement('style');
      stijl.textContent = '#cfTrioTip{margin:0 0 10px;padding:9px 12px;border-radius:8px;background:rgba(232,112,58,0.10);font-size:13px;line-height:1.5;color:#003d63}' +
        '#cfTrioTip button{display:block;width:100%;margin-top:8px;padding:8px 10px;border:0;border-radius:8px;background:#003d63;color:#fff;font-weight:700;font-size:13px;cursor:pointer}' +
        '#cfTrioTip button[disabled]{opacity:.5;cursor:default}';
      document.head.appendChild(stijl);
      el.addEventListener('click', function (e) {
        var knop = e.target.closest('[data-trio-wissel]');
        if (!knop || knop.disabled) return;
        cfTrioWissel(knop);
      });
    }
    el.hidden = false;
    el.innerHTML = cfFmt(CFTRIO.tip, { prijs: CF_TRIO.prijs }) + '<button type="button" data-trio-wissel>' + CFTRIO.knop + '</button>';
  }

  function renderMaskerCadeau(cart, itemsEl) {
    var el = document.getElementById('cfMaskerCadeau');
    if (!CF_MASKER) { if (el) { el.hidden = true; el.innerHTML = ''; } return; }
    if (!el) {
      if (!itemsEl || !itemsEl.parentNode) return;
      el = document.createElement('div');
      el.id = 'cfMaskerCadeau';
      itemsEl.parentNode.insertBefore(el, itemsEl);
      var stijl = document.createElement('style');
      stijl.textContent = '#cfMaskerCadeau{margin:0 0 10px;font-size:13px;line-height:1.5;color:#003d63}' +
        '#cfMaskerCadeau .cfkit{padding:9px 12px;border-radius:8px;background:rgba(237,201,208,0.45)}' +
        '#cfMaskerCadeau .cfkit--klaar{background:rgba(46,160,67,0.12);color:#1f7a33;font-weight:600}' +
        '#cfMaskerCadeau .cfkit--let-op{background:rgba(214,145,20,0.14);color:#8a5a00}' +
        '#cfMaskerCadeau .cfkit__keuze{display:flex;gap:6px;margin-top:8px}' +
        '#cfMaskerCadeau button{flex:1;padding:8px 10px;border:0;border-radius:8px;background:#4B2340;color:#fff;font-weight:700;font-size:13px;cursor:pointer}' +
        '#cfMaskerCadeau button[disabled]{opacity:.5;cursor:not-allowed}' +
        '#cfMaskerCadeau .cfkit__wissel{display:block;width:100%;margin-top:6px;background:transparent;color:#003d63;border:1px solid rgba(0,61,99,.35);font-weight:600}' +
        '#cfMaskerCadeau .cfkit__fout{margin:6px 0 0;color:#b3261e;font-weight:600}';
      document.head.appendChild(stijl);
      el.addEventListener('click', function (e) {
        var knop = e.target.closest('[data-masker-add]');
        if (!knop || knop.disabled) return;
        cfMaskerActie(knop);
      });
    }

    var items = (cart && cart.items) || [];
    var cadeaus = items.filter(cfIsMaskerCadeau);
    var som = cfMaskerSom(items);
    var collageen = cfMaskerMetCollageen(items);
    var colSom = cfMaskerCollageenSom(items);
    var haalt = CF_MASKER.drempel > 0 ? colSom >= CF_MASKER.drempel : collageen;
    var fout = cfMaskerFout ? '<p class="cfkit__fout">' + cfMaskerFout + '</p>' : '';

    if (!cadeaus.length && (som === 0 || !collageen)) { el.hidden = true; el.innerHTML = ''; return; }
    el.hidden = false;

    // Meer dan een gratis masker in de wagen: terugbrengen naar een stuk
    var stuks = cadeaus.reduce(function (n, c) { return n + c.quantity; }, 0);
    if (stuks > 1) {
      var updates = {};
      cadeaus.forEach(function (c, i) { updates[c.key] = i === 0 ? 1 : 0; });
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) })
        .then(function () { return fetchCart().then(renderCart); }).catch(function () {});
      return;
    }

    var varianten = cfMaskerVarianten();
    if (cadeaus.length) {
      cfMaskerFout = '';
      var dit = cadeaus[0];
      var ditKey = (varianten.filter(function (v) { return v.variant === dit.variant_id; })[0] || {}).key;
      var ander = varianten.filter(function (v) { return v.variant !== dit.variant_id; })[0];
      var wissel = ander ? cfMaskerKnop(ander, dit.key) : '';
      if (haalt) {
        el.innerHTML = '<div class="cfkit cfkit--klaar">&#10003; ' +
          cfFmt(CFM.toegevoegd, { naam: CFM.naam[ditKey] || '' }) + wissel + '</div>';
      } else {
        // Onder de drempel gezakt: cadeaumasker automatisch weghalen, zodat niemand
        // ongemerkt een masker betaalt dat hij als cadeau had gekozen.
        el.innerHTML = '<div class="cfkit cfkit--let-op">&#9888; ' +
          (CF_MASKER.drempel > 0 ? cfFmt(CFM.nogNiet, { tekort: cfCadeauBedrag(CF_MASKER.drempel - colSom) }) : CFM.hoortBij) + '</div>';
        fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: dit.key, quantity: 0 }) })
          .then(function () { return fetchCart().then(renderCart); }).catch(function () {});
      }
      return;
    }

    if (haalt) {
      var knoppen = varianten.map(function (v) { return cfMaskerKnop(v); }).join('');
      if (!knoppen) { el.innerHTML = '<div class="cfkit">&#127873; ' + CFM.op + '</div>' + fout; return; }
      el.innerHTML = '<div class="cfkit">&#127873; ' +
        cfFmt(collageen ? CFM.kiesCollageen : CFM.kies, { waarde: cfMaskerWaarde() }) +
        '<div class="cfkit__keuze">' + knoppen + '</div></div>' + fout;
      return;
    }

    el.innerHTML = '<div class="cfkit">&#127873; ' +
      cfFmt(CFM.nogTot, { rest: cfCadeauBedrag(CF_MASKER.drempel - colSom), waarde: cfMaskerWaarde() }) + '</div>' + fout;
  }

  // Testmodus (alleen het testthema): cart-attribuut zodat de Function de nieuwe regels toepast.
  // Op een thema zonder testmodus wordt een achtergebleven attribuut weer leeggemaakt.
  function cfCadeauTestAttribuut() {
    fetchCart().then(function (c) {
      var heeft = c && c.attributes && c.attributes._cf_cadeau_test === '1';
      if (CF_CFG.test && !heeft) {
        return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { _cf_cadeau_test: '1' } }) });
      }
      if (!CF_CFG.test && heeft) {
        return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { _cf_cadeau_test: '' } }) });
      }
      return null;
    }).catch(function () {});
  }

  // ─── INIT ─────────────────────────────────────────────────────────────────

  function init() {
    if (!drawer) return;
    initEvents();
    cfCadeauTestAttribuut();
    // Initieel cart count laden
    fetchCart().then(cart => {
      const countEl = $('cf-cart-count');
      if (countEl) countEl.textContent = cart.item_count || 0;
      document.querySelectorAll('[data-cart-count], #cfm-cart-count').forEach(el => {
        el.textContent = cart.item_count || 0;
      });
    }).catch(() => {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Publieke API
  window.cfCart = { open: openDrawer, close: closeDrawer, refresh: fetchCart };

})();
